<div class="hero__container" [class.collapsed]="menuCollapsed">
  <div class="hero__menu">
    <host-menu [(collapse)]="menuCollapsed"></host-menu>
  </div>
  <div class="hero__content-wrapper">
    <div class="hero__content">
      <div class="hero__conntent-inner">
        <router-outlet/>
      </div>
    </div>
  </div>
</div>
